
import { City } from "@/models/City";
import { DateTime } from "luxon";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Game } from "../../models/Game";

@Component
class DialogGameDetails extends Vue {
  @Prop({ default: null }) readonly gameData!: Game;

  get getStartDateInShortFormat(): string {
    return (
      DateTime.fromISO(this.gameData.start_dt, {
        zone: this.getCityData.tZone?.timeZoneId,
      }).toFormat("dd MMMM yyyy") +
      ", " +
      DateTime.fromISO(this.gameData.start_dt, {
        zone: this.getCityData.tZone?.timeZoneId,
      }).toFormat("HH:mm")
    );
  }
  get getEndDateInShortFormat(): string {
    return (
      DateTime.fromISO(this.gameData.end_dt, {
        zone: this.getCityData.tZone?.timeZoneId,
      }).toFormat("dd MMMM yyyy") +
      ", " +
      DateTime.fromISO(this.gameData.end_dt, {
        zone: this.getCityData.tZone?.timeZoneId,
      }).toFormat("HH:mm")
    );
  }

  get getCityData(): City {
    return this.$store.state.cityStore.singleCity;
  }

  get getTeamCount(): number {
    if (this.gameData.team_count !== undefined) {
      return this.gameData.team_count;
    } else {
      return 0;
    }
  }

  get isAdmin(): boolean {
    return this.$store.getters["authenication/isAdmin"];
  }

  get getTimeZone(): string {
    if (this.getCityData.tZone === undefined) {
      return "Invalid";
    } else {
      return (
        this.getCityData.tZone.timeZoneId +
        ", " +
        this.getCityData.tZone.timeZoneName +
        " (" +
        DateTime.fromISO(this.gameData.start_dt, {
          zone: this.getCityData.tZone!.timeZoneId,
        }).offset /
          60 +
        ")"
      );
    }
  }

  handleClose(): void {
    this.$emit("closeDialog");
  }
}
export default DialogGameDetails;
